import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../context/App-Context";
import axios from "axios";
// BubbleDisplayImg removed for now so it doesn't break!

const UserPostsItem = (props) => {
  const auth = useContext(AuthContext);

  const [data, setData] = useState(null);
  const [postPhotos, setpostPhotos] = useState(null);
  const [previewPhoto, setPreviewPhoto] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Helper to strip year and timezone for the grid view
  const formatShortTime = (timeStr) => {
    if (!timeStr) return "";
    // Turns "september 16, 2026 at 4:04 pm edt" -> "september 16 at 4:04 pm"
    return timeStr
      .replace(/, \d{4}/, "")
      .replace(/\s*[a-z]{3}$/i, "")
      .trim();
  };

  // Fetch Photos
  useEffect(() => {
    setData(null);
    setError(null);
    setLoading(true);

    const fetchPhotos = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/func-rts-upst/getImagesTempleGridpost?username=${auth.loginVar}&uid=${props.postFunction}`
        );
        setpostPhotos(response.data.data.functionGo);
      } catch (err) {
        // console.log(err.message);
      }
    };
    fetchPhotos();
  }, [auth.loginVar, props.postFunction]);

  // Fetch Post Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/func-rts-upst/gettgridpost/${auth.loginVar}/${props.postFunction}`
        );
        setData(response.data.functionGO);
      } catch (err) {
        //console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [auth.loginVar, props.postFunction]);

  return (
    <div>
      {/* Basic Standard Image Modal Overlay */}
      {previewPhoto && (
        <div
          className="photo-preview-modal"
          onClick={() => setPreviewPhoto(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            onClick={() => setPreviewPhoto(null)}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              background: "none",
              color: "#00008b",
              border: "none",
              fontSize: "50px",
              cursor: "pointer",
              zIndex: 10000,
              fontWeight: "100",
              lineHeight: "0.5",
            }}
          >
            ×
          </button>

          <div
            onClick={(e) => e.stopPropagation()}
            style={{ width: "90%", maxWidth: "800px", position: "relative" }}
          >
            <img
              src={previewPhoto.url}
              alt="Fullscreen preview"
              style={{
                width: "100%",
                maxHeight: "80vh",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
            {/* Show Full Timestamp in Modal */}
            {previewPhoto.time && (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "15px",
                  color: "#00008b",
                  fontWeight: "bold",
                }}
              >
                {previewPhoto.time}
              </div>
            )}
          </div>
        </div>
      )}

      {data && (
        <div className="tgrid-post bg-white border border-gray-200 rounded-2xl p-4 mb-3 max-w-[550px] shadow-sm">
          {/* Header */}
          <div className="tgrid-post-header flex items-start gap-3 mb-3">
            <div className="tgrid-post-avatar w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-gray-100 flex items-center justify-center text-2xl">
              👑
            </div>

            <div className="tgrid-post-info flex-1 min-w-0">
              <div className="tgrid-post-name-row flex items-center flex-wrap gap-x-1 text-[15px]">
                <span className="tgrid-post-username font-bold text-[#0f1419]">
                  {auth.loginVar}
                </span>
                <span className="tgrid-post-time text-[#536471]">
                  · {data.postDate}
                </span>
              </div>
            </div>
          </div>

          {/* Post Text */}
          <div className="tgrid-post-text text-[15px] leading-relaxed text-[#0f1419] mb-3 whitespace-pre-wrap">
            {data.postData} {data.postText}
          </div>

          {/* Photo Grid */}
          {/* Photo Grid */}
          {postPhotos && (
            <div>
              <div className="photo-grid">
                {postPhotos.map((photo, index) => {
                  // 🌟 BULLETPROOF EXTRACTION: Handle object keys or raw strings
                  const imgSrc =
                    photo.url ||
                    photo.src ||
                    photo.postImages ||
                    photo.StarPostImages ||
                    photo.StarFormsImages ||
                    (typeof photo === "string" ? photo : "");
                  const imgTime =
                    photo.time ||
                    photo.timestamp ||
                    (data?.imageTimestamps
                      ? data.imageTimestamps[index]
                      : null);

                  return (
                    <div
                      key={photo.key || photo.filename || `photo-${index}`}
                      role="button"
                      tabIndex={0}
                      onClick={() =>
                        setPreviewPhoto({
                          url: imgSrc,
                          time: imgTime,
                        })
                      }
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        marginBottom: "16px",
                        cursor: "pointer",
                      }}
                    >
                      {/* The Image Frame - Isolated so it keeps your CSS styling but can't hide the text below it */}
                      <div
                        className="photo-item"
                        style={{ margin: 0, width: "100%" }}
                      >
                        <img
                          src={imgSrc}
                          alt={photo.filename || `Photo ${index + 1}`}
                          className="photo-img"
                          loading="lazy"
                          style={{
                            width: "100%",
                            height: "auto",
                            display: "block",
                          }}
                        />
                      </div>

                      {/* Timestamp - Rendered OUTSIDE of the restricted photo-item container */}
                      {imgTime && (
                        <div
                          style={{
                            marginTop: "8px",
                            textAlign: "left",
                            paddingLeft: "4px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "12px",
                              color: "#007bff", // Blue text
                              fontWeight: "bold",
                            }}
                          >
                            {formatShortTime(imgTime)}
                          </span>
                        </div>
                      )}

                      {photo.caption && (
                        <div
                          className="photo-caption"
                          style={{ textAlign: "left", marginTop: "4px" }}
                        >
                          {photo.caption}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UserPostsItem;
